import { useEffect, useState } from "react";
import { getAvailableLocales, getLocaleSettings } from "services/localisation";
import { hasSiteAppSession } from "i18n";

const DEFAULT_LOCALE = "en";

// The locale options a language selector can offer within the current site
// app: the shipped locales plus the site's own default. Nothing is fetched
// (enabled=false) outside an active site app session.
const useSiteLocaleOptions = () => {
	const enabled = hasSiteAppSession();

	const [available, setAvailable] = useState([DEFAULT_LOCALE]);
	const [siteDefault, setSiteDefault] = useState(DEFAULT_LOCALE);

	useEffect(() => {
		if (!hasSiteAppSession()) return;

		let active = true;

		(async () => {
			const [localesRes, settingsRes] = await Promise.all([
				getAvailableLocales(),
				getLocaleSettings(),
			]);

			if (!active) return;

			if (localesRes?.status)
				setAvailable(localesRes.data ?? [DEFAULT_LOCALE]);
			if (settingsRes?.status)
				setSiteDefault(settingsRes.data?.defaultLocale ?? DEFAULT_LOCALE);
		})();

		return () => {
			active = false;
		};
	}, []);

	return { enabled, available, siteDefault };
};

export default useSiteLocaleOptions;
